module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_23-f7fa00a76ba2dfdcbf412f2ee50344f6.jpg";